var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.question ? _c('div', [_c('v-divider', {
    staticClass: "grey darken-4"
  }), _c('div', {
    staticClass: "pa-12px py-md-14px grey lighten-4"
  }, [_c('strong', {
    staticClass: "font-size-16"
  }, [_vm._v("Q. " + _vm._s(_vm.question.subject))])]), _c('v-divider'), _c('div', {
    staticClass: "pa-12px py-md-14px"
  }, [_c('span', {
    staticClass: "font-size-14 font-size-md-16"
  }, [_c('strong', {
    staticClass: "font-weight-medium"
  }, [_vm._v("작성일자")]), _vm._v(" : " + _vm._s(_vm.$dayjs(_vm.question.createdAt).format("YYYY-MM-DD HH:mm:ss")))])]), _c('v-divider'), _c('div', {
    staticClass: "font-size-14 font-size-md-16 pa-12px py-20px min-h-200px"
  }, [_c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.content)
    }
  })]), _c('v-divider'), _c('div', {
    staticClass: "font-size-14 font-size-md-16 pa-12px py-20px min-h-200px"
  }, [_vm._m(0), _vm.question.answer ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.question.answer)
    }
  }) : _c('p', [_vm._v("관리자가 문의내용을 확인하고 있습니다."), _c('br'), _vm._v("조금만 기다려 주시면 성심성의껏 답변해 드리겠습니다.")])]), _c('v-divider')], 1) : _vm._e();
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "mb-10px"
  }, [_c('strong', {
    staticClass: "font-size-16"
  }, [_vm._v("A. 관리자 답변")])]);
}]

export { render, staticRenderFns }